import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RuleParam, RuleParamDataType } from './../ruleparamlist/ruleparam.model';
import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { RuleParamService } from './../rule-param.service';

@Component({
    selector: 'add-ruleparam',
    templateUrl: './add-ruleparam.component.html',
    styleUrls: ['./add-ruleparam.component.css']
})
export class AddRuleParamComponent implements OnInit {

    selectedRuleParam: RuleParam;
    ruleParamForm: FormGroup;
    arrDataType: RuleParamDataType[];

    formErrors = {
        'key': '',
        'description': '',
        'dataType': '',
        'value': '',
    };

    validationMessages = {
        'key': {
            'required': 'Required field value.',
        },
        'description': {
            'required': 'Required field value.',
        },
        'dataType': {
            'required': 'Required field value.',
        },
        'value': {
            'required': 'Required field value.',
        },

    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private fb: FormBuilder,
        private ruleParamService: RuleParamService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    ngOnInit() {
        this.createForm();
        this.updateRuleParamForm();
    }

    createForm() {
        this.ruleParamForm = this.fb.group({
            key: ['', Validators.required],
            description: ['', Validators.required],
            dataType: ['', Validators.required],
            value: ['', Validators.required],
            isCollection: [false, Validators.required],
        });
        this.ruleParamForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    onValueChanged(data?: any) {
        if (!this.ruleParamForm) {
            return;
        }
        const form = this.ruleParamForm;
        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);
            if (control && control.touched && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }
    onSubmit({ value, valid }) {
        const updateParam = new RuleParam();
        updateParam.key = value.key;
        updateParam.description = value.description;
        updateParam.dataType = value.dataType;
        value.dataTypeDisplay = this.arrDataType.find(o => o.id === value.dataType).name;
        updateParam.dataTypeDisplay = value.dataTypeDisplay;
        updateParam.value = value.value;
        updateParam.id = value.id;
        updateParam.isCollection = value.isCollection;
        if (this.selectedRuleParam) {
            this.updateParam(updateParam);
        } else {
            this.createParam(updateParam);
        }

    }
    createParam(updateParam: RuleParam): any {
        this.ruleParamService.addRuleParam(updateParam)
            .subscribe(
            success => {
                updateParam.id = success.message;
                success.message = null;
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_PARAM_MANAGEMENT,
                    TrackingConstants.ADD_RULE_PARAM,
                    TrackingConstants.SUCCESS, 1);
                this.callSnackBarService(success, MessageService.ADD_RULE_PARAM_SUCCESS, MessageService.ADD_RULE_PARAM_FAILURE);
                this.closeDialog(updateParam);
            },
            err => {
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_PARAM_MANAGEMENT,
                    TrackingConstants.ADD_RULE_PARAM,
                    TrackingConstants.FAILURE, 0);
                this.callSnackBarService(err, MessageService.ADD_RULE_PARAM_SUCCESS, MessageService.ADD_RULE_PARAM_FAILURE);
            }
            );
    }
    updateParam(updateParam: RuleParam) {
        updateParam.id = this.selectedRuleParam.id;
        this.ruleParamService.updateRuleParam(updateParam)
            .subscribe(
            success => {
                if (success.flagResult) {
                    this.closeDialog(updateParam);
                }
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_PARAM_MANAGEMENT,
                    TrackingConstants.UPDATE_RULE_PARAM,
                    TrackingConstants.SUCCESS, 1);
                this.callSnackBarService(success, MessageService.UPDATE_RULE_PARAM_SUCCESS, MessageService.UPDATE_RULE_PARAM_FAILURE);
            },
            err => {
                this.trackingService
                    .emitEvent(
                    TrackingConstants.RULE_PARAM_MANAGEMENT,
                    TrackingConstants.UPDATE_RULE_PARAM,
                    TrackingConstants.FAILURE, 0);
                this.callSnackBarService(err, MessageService.UPDATE_RULE_PARAM_SUCCESS, MessageService.UPDATE_RULE_PARAM_FAILURE);
            }
            );
    }
    closeDialog(formResponse: Object): void {
        this.ruleParamForm.reset();
        this.selectedRuleParam = null;
        this.dialogRef.close(formResponse);
    }
    updateRuleParamForm(): void {
        if (this.selectedRuleParam) {
            this.ruleParamForm.patchValue(this.selectedRuleParam);
        }
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService
            .showStatus(response,
            successMsg,
            failureMsg);
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/rules/addruleparam/add-ruleparam.component.ts